import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { LocalDataCacheService } from '..';
import { CustomizedHttpService } from '../base/customized-http.service';

@Injectable({
  providedIn: 'root'
})
export class EmailLandingService {
  constructor(private httpService: CustomizedHttpService, private localDataStorage: LocalDataCacheService) { }

  getLandingResponse(): Observable<any> {
    let IsMobileDevice = this.localDataStorage.getSessionStorage().getItem("MobileTracking") == "MobileTrackingDevice";
    return this.httpService.post<any, any>('emaillanding/processquotelanding', {IsMobileDevice : IsMobileDevice});
  }

  generateClientSignature(): Observable<string> {
    return this.httpService.get<string>('emaillanding/generateclientsignature');
  }
}
